import { action } from 'satcheljs';

export default action('POPULATE_PUBLIC_FOLDER_OUTLOOK_FAVORITE_STORE');
